import { Component, Input } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { Router } from '@angular/router';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';
import { EmpresaService } from '../../core/services/empresa/empresa.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Input() title: string = '';

  constructor(
    public authService: AuthService,
    public empresaService: EmpresaService,
    public router: Router,
    public sideMenuService: SideMenuService
  ) {

  }

}
